import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoField, GeckoAvatar, GECKO_CONSTS } from 'ui';
import AsyncSelect from 'components/AsyncSelect';

import './index.scss';

class ContactSelect extends Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    disabledContacts: [],
  };

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  renderOption(option) {
    const { contact } = option;
    return (
      <div className={`ContactSelect-option`}>
        <div className="ContactSelect-option-avatar">
          <GeckoAvatar
            name={contact.full_name}
            first_name={contact.first_name}
            last_name={contact.last_name}
            size="sm"
            color={contact.additional.avatar_colour}
            bgImage={
              contact.additional ? contact.additional.profile_picture_url : null
            }
          />
        </div>
        <div className="ContactSelect-option-name">{contact.full_name}</div>
        <div className="ContactSelect-option-email">{contact.email || '-'}</div>
        <div className="ContactSelect-option-telephone">
          {contact.tel || '-'}
        </div>
      </div>
    );
  }

  filterOption(option, rawSearch) {
    const normalise = (str) => (str || '').toLowerCase();
    const search = normalise(rawSearch);
    const { contact } = option;
    if (this.props.disabledContacts.includes(contact.id)) {
      return false;
    }
    if (normalise(contact.full_name).includes(search)) {
      return true;
    }
    if (normalise(contact.email).includes(search)) {
      return true;
    }
    // For number we want to strip off leading 0's so +44... and 0... are agnostic
    const numberSearch =
      search[0] === '0' ? search.slice(1, search.length) : search;
    if (normalise(contact.tel).includes(numberSearch)) {
      return true;
    }
    return false;
  }

  render() {
    const field = {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: (
        <AsyncSelect
          selectUrl="/contact"
          getUrl="/contact"
          optionTransform={(contact) => ({
            label: `${contact.full_name} ${contact.email} ${contact.tel}`,
            value: contact.id,
            contact,
          })}
          field={{
            config: {
              optionRenderer: this.renderOption.bind(this),
              valueRenderer: this.renderOption.bind(this),
              filterOption: this.filterOption.bind(this),
            },
          }}
        />
      ),
    };

    return (
      <div className="ContactSelect">
        <GeckoField
          values={{ value: this.props.value }}
          field={field}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default ContactSelect;
